import React from "react";
import "../css/privacy-policy.css";

const sections = [
  {
    title: "Scope",
    body: [
      "This Privacy Policy applies to the Cling website only. Cling™ is a product of ClubIn Platforms Pvt. Ltd., an India-based company. If you use the Cling mobile app or other Cling services with additional features, separate or additional privacy disclosures may apply to those products and services.",
    ],
  },
  {
    title: "Information We May Collect",
    bullets: [
      "basic technical information such as browser type, device type, operating system, language, IP address, and approximate location derived from IP",
      "website usage information such as pages visited, time spent, referral source, and interactions with website content",
      "information you voluntarily submit through contact forms, inquiry forms, newsletter signups, or similar website features",
      "cookies and similar technologies used for site performance, analytics, security, or user preferences",
    ],
  },
  {
    title: "How We Use Information",
    bullets: [
      "operate, maintain, and improve the website",
      "understand traffic, usage trends, and visitor engagement",
      "respond to inquiries or requests submitted through the website",
      "maintain website security and prevent abuse",
      "troubleshoot technical issues",
      "communicate with you if you voluntarily submit your contact information",
    ],
  },
  {
    title: "Cookies and Analytics",
    body: [
      "The website may use cookies or similar technologies to support functionality, measure usage, and improve performance. If analytics tools or similar services are used, those tools may collect information about website visits and interactions. You can manage cookies through your browser settings, though some site features may be affected.",
    ],
  },
  {
    title: "How Information May Be Shared",
    body: ["Cling may share website-related information:"],
    bullets: [
      "with vendors or service providers who help host, secure, maintain, or analyze the website",
      "when required by law, legal process, or to protect rights, safety, or security",
      "in connection with a business transfer such as a merger, acquisition, restructuring, or sale of assets",
    ],
    footer:
      "Cling does not sell personal information in the ordinary sense of selling user identities for unrelated third-party use.",
  },
  {
    title: "Data Retention",
    body: [
      "Cling may retain website-related information for as long as reasonably necessary to operate the website, respond to requests, maintain security, comply with legal obligations, and resolve disputes.",
    ],
  },
  {
    title: "Security",
    body: [
      "Cling uses reasonable administrative, technical, and organizational measures to protect information collected through the website. However, no method of transmission or storage is completely secure, and absolute security cannot be guaranteed.",
    ],
  },
  {
    title: "Third-Party Services and Links",
    body: [
      "The website may contain links to third-party websites or may rely on third-party tools such as hosting, analytics, form handling, or embedded content providers. Those third parties may process information according to their own privacy policies.",
    ],
  },
  {
    title: "Children",
    body: [
      "The website is not intended to knowingly collect personal information from children in violation of applicable law. If Cling learns that such information has been collected improperly, Cling will take appropriate steps to delete it.",
    ],
  },
  {
    title: "Your Choices",
    bullets: [
      "control cookies through your browser settings",
      "choose whether to submit contact or inquiry information",
      "request access to, correction of, or deletion of personal information where required by applicable law",
    ],
  },
  {
    title: "Changes to This Policy",
    body: [
      "Cling may update this Privacy Policy from time to time. Updated versions will become effective when posted on the website unless otherwise stated. Continued use of the website after changes are posted means you acknowledge the updated policy.",
    ],
  },
  {
    title: "Contact",
    body: [
      "If you have questions about this Privacy Policy or website privacy practices, please contact ClubIn Platforms Pvt. Ltd., the India-based company operating Cling™, using the contact details provided on the website.",
    ],
  },
];

const PrivacyPolicy = () => {
  return (
    <div className="legal-document">
      <div className="legal-document__hero">
        <p className="legal-document__eyebrow">Website Privacy Policy</p>
        <h1>Privacy Notice for www.clingsocial.com</h1>
        <p className="legal-document__meta">Effective Date: August 2, 2026</p>
        <p className="legal-document__lead">
          ClubIn Platforms Pvt. Ltd., an India-based company operating the Cling™ website and
          brand experience, respects your privacy. This Privacy Policy explains how information
          may be collected, used, and protected when you visit or interact with the website
          located at www.clingsocial.com.
        </p>
      </div>

      <div className="legal-document__sections">
        {sections.map((section) => (
          <section className="legal-document__section" key={section.title}>
            <h2>{section.title}</h2>
            {section.body?.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
            {section.bullets ? (
              <ul>
                {section.bullets.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            ) : null}
            {section.footer ? <p>{section.footer}</p> : null}
          </section>
        ))}
      </div>
    </div>
  );
};

export default PrivacyPolicy;
